import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Joins class names and lets a later Tailwind utility win over an earlier one of
 * the same kind. Without the merge, `cn('px-4', 'px-2')` would emit both and the
 * outcome would depend on the order inside the generated stylesheet rather than
 * on the order of the arguments.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
